import { RadioCardGroup, RadioCardProps } from 'components/RadioCard';
import { useCampaignCreation } from 'pages/AdCampaignPage/CampaignCreationContext';
import { useMemo } from 'react';
import { useIsProGrow } from 'state/pricing';
import { BudgetValue } from './types';
import { getPurchasablePrices } from './utils';

export interface PricingOptionsProps {}

const PricingOptions: React.FC<PricingOptionsProps> = () => {
  const {
    state: {
      pricesList,
      isCustomBudget,
      minCustomBudget,
      values: { campaignBudgetMilliCent, sponsorPlacement },
    },
    dispatch,
  } = useCampaignCreation();

  const { data: isProGrow } = useIsProGrow();

  const purchasablePrices = useMemo(
    () => getPurchasablePrices(pricesList, isProGrow),
    [isProGrow, pricesList],
  );

  const defaultBudget = campaignBudgetMilliCent ?? purchasablePrices[0].value;
  const labelPlacement = sponsorPlacement === 'headlinerApp' ? 'end' : 'bottom';
  const currentValue: BudgetValue = isCustomBudget ? 'custom' : defaultBudget;

  const options = useMemo((): RadioCardProps<BudgetValue>[] => {
    const priceOptions: RadioCardProps<BudgetValue>[] = purchasablePrices.map(
      (price) => ({
        value: price.value,
        label: price.label,
        description: price.description,
      }),
    );

    const customOption: RadioCardProps<BudgetValue> = {
      value: 'custom',
      label: 'Custom budget',
      description: `$${minCustomBudget} and Up`,
    };

    return [...priceOptions, customOption];
  }, [minCustomBudget, purchasablePrices]);

  const handleChange = (value: BudgetValue): void => {
    const isCustom = value === 'custom';

    dispatch({
      type: 'TOGGLE_IS_CUSTOM_BUDGET',
      payload: isCustom,
    });

    dispatch({
      type: 'CHANGE_VALUES',
      payload: {
        campaignBudgetMilliCent: isCustom ? undefined : value,
      },
    });
  };

  return (
    <RadioCardGroup
      {...{ options, labelPlacement }}
      row
      aria-labelledby="title"
      name="prices-radio-buttons-group"
      value={currentValue}
      onChange={handleChange}
      gap={labelPlacement === 'bottom' ? '8px' : '14px'}
    />
  );
};

export default PricingOptions;
